module.exports = require("rxjs/ajax");